import { render } from "./AdminSign.vue?vue&type=template&id=1885c1d5&scoped=true"
import script from "./AdminSign.vue?vue&type=script&lang=js"
export * from "./AdminSign.vue?vue&type=script&lang=js"

import "./AdminSign.vue?vue&type=style&index=0&id=1885c1d5&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/user.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1885c1d5"]])

export default __exports__